<template>
  <DialogScrollContent class="tw:outline-0" :class="
  cn([
      {
        'tw:sm:max-w-md': size === 'sm',
        'tw:sm:max-w-lg': size === 'md',
        'tw:sm:max-w-3xl': size === 'lg',
        'tw:sm:max-w-6xl': size === 'xl',
      }
    ],
    props.class
  )" v-bind="forwarded">
    <slot />
  </DialogScrollContent>
</template>

<script setup lang="ts">
import { cn } from '@/shadcn/lib/utils'
import {DialogScrollContent} from "@/shadcn/components/ui/dialog";
import {
  type DialogContentEmits,
  type DialogContentProps,
  useForwardPropsEmits,
} from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = withDefaults(defineProps<DialogContentProps & {
  class?: HTMLAttributes['class'],
  size?: 'sm' | 'md' | 'lg' | 'xl'
}>(), {
  size: 'md'
});

const emits = defineEmits<DialogContentEmits & {
  'enter': () => void
  'leave': () => void
  'after-enter': () => void
  'after-leave': () => void
}>()

const delegatedProps = computed(() => {
  const { class: _, size: __, ...delegated } = props

  return delegated
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)

</script>
